<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">SA追踪</h3>
      </v-card-title>

      <v-form>
        <v-container fluid>
          <v-layout rowwrap>
            <v-flex xs2>
              <v-text-field clearable label="批次" v-model="query.batchNo" />
            </v-flex>
            <v-flex xs2>
              <v-select :items="status" clearable label="状态" v-model="query.status" />
            </v-flex>
            <v-flex xs2>
              <v-text-field clearable label="D/O No" v-model="query.doNo" />
            </v-flex>
            <v-flex xs2>
              <v-text-field clearable label="Invoice No" v-model="query.invoiceNo" />
            </v-flex>
            <v-flex xs2>
              <v-text-field clearable label="Master B/L No" v-model="query.masterBlNo" />
            </v-flex>
            <v-flex xs2>
              <v-text-field clearable label="House B/L No" v-model="query.houseBlNo" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-card-actions>
        <v-btn @click="loadAll">全部</v-btn>
        <v-btn @click="loadPre">Pre SA</v-btn>
        <v-btn @click="loadFormal">本 SA</v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10, 20, 50, 100, 200, 500, 1000]"
        :total-items="pagination.totalItems"
        item-key="id"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.batchNo }}</td>
          <td>{{ props.item.batchSeq }}</td>
          <td>{{ props.item.creationDateTime }}</td>
          <td>{{ props.item.buCode }}</td>
          <td>{{ props.item.handleFlag }}</td>
          <td>{{ props.item.type }}</td>
          <td>{{ props.item.doNo}}</td>
          <td>{{ props.item.invoiceNo}}</td>
          <td>{{ props.item.masterBlNo}}</td>
          <td>{{ props.item.houseBlNo}}</td>
          <td>{{ props.item.aedat}}</td>
          <td>{{ props.item.aezet}}</td>
          <td>{{ props.item.status}}</td>
          <td>{{ props.item.error}}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import qs from 'qs'
export default {
  data() {
    return {
      query: {},
      loading: false,
      status: ['PENDING', 'NORMAL', 'ERROR', 'ABANDON'],
      headers: [
        { text: '批次', value: 'batchNo', sortable: false, width: '120' },
        { text: '序号', value: 'batchSeq', sortable: false, width: '40' },
        {
          text: '创建时间',
          value: 'creationDateTime',
          sortable: false,
          width: '120'
        },
        { text: '事业部', value: 'buCode', sortable: false, width: '40' },
        { text: '指令', value: 'handleFlag', sortable: false, width: '50' },
        { text: '类型', value: 'type', sortable: false, width: '30' },
        { text: 'D/O No', value: 'doNo', sortable: false, width: '80' },
        {
          text: 'Invoice No',
          value: 'invoiceNo',
          sortable: false,
          width: '80'
        },
        {
          text: 'Master B/L No',
          value: 'masterBlNo',
          sortable: false,
          width: '120'
        },
        {
          text: 'House D/O No',
          value: 'houseBlNo',
          sortable: false,
          width: '120'
        },
        { text: 'AEDAT', value: 'aedat', sortable: false, width: '60' },
        { text: 'AEZET', value: 'aezet', sortable: false, width: '50' },
        { text: '状态', value: 'status', sortable: false, width: '60' },
        { text: '错误原因', value: 'error', sortable: false }
      ],
      items: [],
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  methods: {
    loadAll() {
      this.query.type = null
      this.pagination.page = 1
      this.loadData()
    },
    loadPre() {
      this.query.type = 'PRE'
      this.pagination.page = 1
      this.loadData()
    },
    loadFormal() {
      this.query.type = 'FORMAL'
      this.pagination.page = 1
      this.loadData()
    },
    loadData() {
      this.loading = true
      this.$http
        .get(`/b2b/sa/tracking`, {
          params: {
            ...this.query,
            page: this.pagination.page - 1,
            size: this.pagination.rowsPerPage,
            sort: ['b2bMeta.batchNo,desc', 'b2bMeta.batchSeq,asc']
          },
          paramsSerializer: params => {
            return qs.stringify(params, { indices: false })
          }
        })
        .then(res => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.items = res.data.content
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  },
  watch: {
    pagination() {
      this.loadData()
    }
  }
}
</script>
